var _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccordionUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    enableBackground: "new 0 0 20 12",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 20,
    height: 12,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAMAAABV0m3JAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAZlBMVEX////8/P3j5ezr7PHl 5+2Jkqx0f56dpbv39/ni5Ot9h6STm7Pk5ux+iKV1f569wtGhqL2RmrN1gJ/IzNmhqb6Sm7Pi5OrI zdmiqb6HkKvHy9j9/f2jqr+psMN9iKSRmrL29/n19vg8bb7WAAAAAWJLR0QAiAUdSAAAAAlwSFlz AAAAYAAAAGAA8GtCzwAAAAd0SU1FB+YMAQYRGtuzfoMAAABiSURBVAjXXc9XDoQwEANQhwUTlt47 LPe/JNGKkok/n6yRB7iivA/c+AEZamnRlyax0CRllhdkqUWvqqEastXSIPQ2W197tTPWP9fV8NeR 2WTtmBdyRbf19jjT3X/A4fw2a5z65ATpFA4zrQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMi0xMi0w MVQwNjoxNzoyNSswMDowMA7dMOoAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMTItMDFUMDY6MTc6 MjUrMDA6MDB/gIhWAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIyLTEyLTAxVDA2OjE3OjI2KzAw OjAwGX2zFAAAAABJRU5ErkJggg=="
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionUp);
export default __webpack_public_path__ + "static/media/accordion-up.a08173c9d536ed638b9907cd1de8e20d.svg";
export { ForwardRef as ReactComponent };